import { BookOpen, Github, PenTool, Newspaper, Wrench } from 'lucide-react';
import { 减压, 公众号, beian } from '../assets/images';

// 社交链接配置
const socialLinks = [
  {
    icon: BookOpen,
    label: '博客',
    href: 'https://mmbang.site/',
  },
  {
    icon: Github,
    label: 'GitHub',
    href: 'https://github.com/yyISACoder',
  },
  {
    icon: PenTool,
    label: '掘金',
    href: 'https://juejin.cn/user/712139266332670',
  },
];

// 其他项目链接配置
const otherProjectsLinks = [
  {
    icon: Newspaper,
    label: '时事热点',
    href: 'https://news.mmbang.site/',
  },
  {
    icon: Wrench,
    label: 'Carl的工具箱',
    href: 'https://tools.mmbang.site/',
  },
];

// 链接项组件
function LinkItem({
  icon: Icon,
  label,
  href,
}: {
  icon: typeof BookOpen;
  label: string;
  href: string;
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex items-center gap-3 text-[#848484] hover:text-[#C9A962] transition-colors duration-300"
    >
      <Icon className="w-[18px] h-[18px] transition-colors duration-300" />
      <span className="text-sm font-medium">{label}</span>
    </a>
  );
}

// 区块标题组件
function SectionTitle({ children }: { children: React.ReactNode }) {
  return (
    <h3
      className="text-white text-xl font-medium"
      style={{ fontFamily: "'Cormorant Garamond', serif" }}
    >
      {children}
    </h3>
  );
}

// 二维码项组件
function QRItem({
  src,
  alt,
  label,
}: {
  src: string;
  alt: string;
  label: string;
}) {
  return (
    <div className="flex flex-col items-center gap-3">
      <div className="w-[100px] h-[100px] rounded-lg border border-[#2A2A2A] overflow-hidden bg-[#141414]">
        <img src={src} alt={alt} className="w-full h-full object-cover" />
      </div>
      <span className="text-xs text-[#848484]">{label}</span>
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="w-full bg-[#0B0F19] py-0">
      {/* 顶部边框 */}
      <div className="w-full h-px bg-[#2A2A2A]" />

      {/* 主内容区 */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-12">
        <div className="py-10 md:py-12">
          <div className="flex flex-col md:flex-row justify-between gap-10 md:gap-16 lg:gap-20">
            {/* 左侧 - 品牌与社交链接 */}
            <div className="flex flex-col gap-8">
              {/* 品牌名 */}
              <h2
                className="text-white text-[28px] font-medium tracking-tight"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                个人主页
              </h2>

              {/* 社交链接 */}
              <div className="flex flex-col gap-4">
                {socialLinks.map((link) => (
                  <LinkItem key={link.label} {...link} />
                ))}
              </div>
            </div>

            {/* 中间 - 其他项目 */}
            <div className="flex flex-col gap-8">
              <SectionTitle>其他项目</SectionTitle>
              {/* 链接列表 */}
              <div className="flex flex-col gap-4">
                {otherProjectsLinks.map((link) => (
                  <LinkItem key={link.label} {...link} />
                ))}
              </div>
              {/* 赛博减压二维码 - 无标签版本，向上偏移10px */}
              <div className="w-[100px] h-[100px] rounded-lg border border-[#2A2A2A] overflow-hidden bg-[#141414] -mt-[10px]">
                <img
                  src={减压}
                  alt="赛博减压小程序"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* 右侧 - 关注我 */}
            <div className="flex flex-col gap-8">
              <SectionTitle>关注我</SectionTitle>
              <div className="flex gap-8">
                <QRItem src={公众号} alt="公众号" label="公众号" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 底部边框 */}
      <div className="w-full h-px bg-[#2A2A2A]" />

      {/* 备案信息 */}
      <div className="w-full py-4 bg-[#0B0F19]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-12">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-xs text-[#848484]">
            {/* 网安备案 */}
            <a
              href="https://beian.mps.gov.cn/#/query/webSearch?code=51010502015643"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 hover:text-[#C9A962] transition-colors duration-300"
            >
              {/* 网安备案图标 */}
              <img
                src={beian}
                alt="网安备案"
                className="w-4 h-4 object-contain"
              />
              <span>川公网安备51010502015643号</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
